module.exports = __webpack_public_path__ + "img/user.1e3c0343.svg";